export enum FORM_TYPE {
	TEXT = 'text',
	TEXT_AREA = 'textarea',
	RADIO = 'radio',
	CHECKBOX = 'checkbox',
	DROPDOWN = 'dropdown',
	EMAIL = 'email',
	DATE_PICKER = 'date',
	TEL = 'tel',
}

export enum FORM_STATUS {
	DRAFT = 0,
	DRAFT_TO_BE_ONLINE = 1,
	ONLINE = 10,
	ARCHIVED = 20,
}